// src/features/feedback/types.ts
//
// 上限値は firestore.rules / storage.rules の feedback ブロックと同じ値にすること。

export const FEEDBACK_COLLECTION = 'feedback';
export const FEEDBACK_STORAGE_ROOT = 'feedback';

export const FEEDBACK_CATEGORIES = ['bug', 'improvement', 'feature', 'ux', 'other'] as const;
export type FeedbackCategory = (typeof FEEDBACK_CATEGORIES)[number];

export const FEEDBACK_STATUSES = ['open', 'inProgress', 'done'] as const;
export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[number];

export const FEEDBACK_LIMITS = {
  titleMax: 200,
  bodyMax: 8000,
  expectedMax: 2000,
  actualMax: 2000,
  attachmentsMax: 4,
  imageBytesMax: 5 * 1024 * 1024,
  consoleErrorsMax: 10,
  consoleErrorLength: 500,
} as const;

export function categoryNeedsExpectedActual(category: FeedbackCategory): boolean {
  return category === 'bug';
}

export type FeedbackViewport = { w: number; h: number; dpr: number };

export type FeedbackContext = {
  workspaceId: string | null;
  path: string;
  href: string;
  pageTitle: string;
  viewport: FeedbackViewport;
  userAgent: string;
  timezone: string;
  uiLanguage: string;
  appBuildId: string;
  consoleErrors: string[];
};

export type FeedbackAttachment = {
  path: string;
  contentType: string;
  size: number;
};

export type FeedbackFile = {
  id: string;
  blob: Blob;
  filename: string;
  previewUrl: string;
};

export type FeedbackDoc = FeedbackContext & {
  id: string;
  category: FeedbackCategory;
  title: string;
  body: string;
  expected?: string;
  actual?: string;
  status: FeedbackStatus;
  reporterUid: string;
  reporterEmail: string;
  reporterName: string;
  attachments: FeedbackAttachment[];
  submittedAtMs: number | null;
  updatedAtMs: number | null;
};
